(() => {
  const DL = window.DL || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* money */
  function formatMoney(cents, format = DL.moneyFormat || '{{amount_with_comma_separator}} €') {
    cents = Number(cents) || 0;
    const fmt = (n, d, ts = ',', ds = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2),
      amount_no_decimals: fmt(cents, 0),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_space_separator: fmt(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: fmt(cents, 0, ' ', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.')
    }[k] ?? fmt(cents, 2)));
  }

  /* toast */
  function toast(t) {
    const el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('show');
    clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('show'), 2200);
  }

  /* drawers */
  const scrim = $('#scrim');
  let openDrawer = null;
  function setDrawer(el, open) {
    if (!el) return;
    if (open && openDrawer && openDrawer !== el) setDrawer(openDrawer, false);
    el.classList.toggle('open', open);
    el.setAttribute('aria-hidden', String(!open));
    scrim.hidden = !open;
    document.body.classList.toggle('no-scroll', open);
    document.body.classList.toggle('menu-open', open && el.id === 'mnav');
    openDrawer = open ? el : null;
    if (open) setTimeout(() => (el.querySelector('[data-autofocus]') || el.querySelector('button'))?.focus(), 50);
  }
  scrim?.addEventListener('click', () => setDrawer(openDrawer, false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && openDrawer) setDrawer(openDrawer, false); });

  /* cart */
  const drawer = $('#cart-drawer');
  const placeholderImg = '<div class="ph"></div>';
  function setCount(n) { $$('[data-cart-count]').forEach(b => { b.textContent = n; b.dataset.n = n; }); }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    const goal = Number(drawer.dataset.freeShipping || 0);
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    const ship = $('[data-cart-ship]', drawer);
    if (ship) {
      if (goal > 0 && cart.item_count) {
        const left = Math.max(0, goal - cart.total_price);
        ship.innerHTML = (left > 0
          ? `Plus que <b>${formatMoney(left)}</b> pour la livraison offerte.`
          : esc(drawer.dataset.shipOk)) + `<div class="bar"><i style="width:${Math.min(100, cart.total_price / goal * 100)}%"></i></div>`;
      } else ship.textContent = cart.item_count ? drawer.dataset.shipOk : drawer.dataset.shipEmpty;
    }
    $('[data-cart-lines]', drawer).innerHTML = cart.items.length ? cart.items.map((l, i) => `
      <div class="line">
        <a href="${esc(l.url)}">${l.image ? `<img src="${esc(l.image + (l.image.includes('?') ? '&' : '?') + 'width=200')}" alt="" width="72" height="96">` : placeholderImg}</a>
        <div>
          <h5><a href="${esc(l.url)}">${esc(l.product_title)}</a></h5>
          ${l.product_has_only_default_variant ? '' : `<div class="meta">${l.options_with_values.map(o => esc(o.value)).join(' · ')}</div>`}
          ${(l.selling_plan_allocation ? `<div class="meta">${esc(l.selling_plan_allocation.selling_plan.name)}</div>` : '')}
          <div class="qty"><button type="button" data-line="${i + 1}" data-q="${l.quantity - 1}" aria-label="Retirer un">−</button><span>${l.quantity}</span><button type="button" data-line="${i + 1}" data-q="${l.quantity + 1}" aria-label="Ajouter un">+</button></div>
          <button type="button" class="rm" data-line="${i + 1}" data-q="0">Retirer</button>
        </div>
        <span class="mono">${l.original_line_price !== l.final_line_price ? `<s>${formatMoney(l.original_line_price)}</s><br>` : ''}${formatMoney(l.final_line_price)}</span>
      </div>`).join('')
      : `<p class="empty">Votre panier est vide.</p>`;
    const co = $('[data-checkout]', drawer);
    if (co) co.disabled = !cart.items.length;
  }

  async function refreshCart() {
    const r = await fetch((DL.routes?.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } });
    const cart = await r.json(); renderCart(cart); return cart;
  }

  async function changeLine(line, quantity) {
    drawer?.classList.add('busy');
    try {
      const r = await fetch((DL.routes?.cart_change || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || cart.message);
      renderCart(cart);
    } catch (e) { toast(e.message || 'Erreur, veuillez réessayer'); await refreshCart(); }
    drawer?.classList.remove('busy');
  }

  async function addToCart(formData, label) {
    const r = await fetch((DL.routes?.cart_add || '/cart/add') + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
    const res = await r.json();
    if (!r.ok) { toast(res.description || res.message || 'Impossible d’ajouter cet article'); return false; }
    if (DL.cartType === 'page') { location.href = DL.routes?.cart || '/cart'; return true; }
    await refreshCart();
    if (DL.cartType === 'toast' || !drawer) toast(`${label || res.product_title} ajouté au panier`);
    else setDrawer(drawer, true);
    return true;
  }

  drawer?.addEventListener('click', e => {
    const b = e.target.closest('[data-line]');
    if (b) changeLine(Number(b.dataset.line), Number(b.dataset.q));
  });
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => {
    if (!drawer || DL.cartType === 'page') return;
    e.preventDefault(); setDrawer(drawer, true);
  }));
  $$('[data-close-drawer]').forEach(b => b.addEventListener('click', () => setDrawer(openDrawer, false)));
  $$('[data-open-menu]').forEach(b => b.addEventListener('click', () => setDrawer($('#mnav'), true)));

  /* quick add from cards */
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    const fd = new FormData(); fd.append('id', q.dataset.quickAdd); fd.append('quantity', 1);
    q.disabled = true;
    await addToCart(fd, `${q.dataset.title} · ${q.textContent.trim()}`);
    q.disabled = false;
  });

  /* favorites (per-browser) */
  let favs;
  try { favs = new Set(JSON.parse(localStorage.getItem('dl_favs') || '[]')); } catch { favs = new Set(); }
  const syncFavs = () => {
    $$('[data-fav]').forEach(b => b.setAttribute('aria-pressed', favs.has(b.dataset.fav)));
    $$('[data-fav-count]').forEach(b => { b.textContent = favs.size; b.dataset.n = favs.size; });
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fav]'); if (!b) return;
    e.preventDefault();
    const id = b.dataset.fav;
    favs.has(id) ? favs.delete(id) : favs.add(id);
    try { localStorage.setItem('dl_favs', JSON.stringify([...favs])); } catch {}
    syncFavs(); toast(favs.has(id) ? 'Ajouté aux favoris' : 'Retiré des favoris');
  });
  syncFavs();

  /* tabs (product grid chips) */
  $$('[data-tabs]').forEach(root => {
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-tab]'); if (!b) return;
      $$('[data-tab]', root).forEach(x => x.setAttribute('aria-pressed', x === b));
      $$('[data-panel]', root).forEach(p => { p.hidden = p.dataset.panel !== b.dataset.tab; });
      const p = $(`[data-panel="${b.dataset.tab}"]`, root);
      const c = $('[data-count]', root); if (c && p) c.textContent = p.dataset.countLabel || '';
    });
  });

  /* product form */
  $$('[data-product-form]').forEach(root => {
    const data = JSON.parse($('[data-product-json]', root)?.textContent || 'null');
    if (!data) return;
    const form = $('form[action*="/cart/add"]', root);
    const idInput = $('input[name="id"]', form);
    const addBtn = $('[data-add]', root);
    const hint = $('[data-size-hint]', root);
    const priceEl = $('[data-price]', root);
    const skuEl = $('[data-sku]', root);
    const groups = $$('[data-option]', root);
    const sel = groups.map(g => $('[aria-pressed="true"]', g)?.dataset.value ?? null);
    const labels = { add: addBtn?.dataset.labelAdd || 'Ajouter au panier', sold: addBtn?.dataset.labelSold || 'Épuisé' };

    const current = () => !groups.length
      ? (data.variants.find(v => String(v.id) === idInput?.value) || data.variants[0])
      : sel.includes(null) ? null : data.variants.find(v => v.options.every((o, i) => o === sel[i]));

    function paint() {
      const v = current();
      groups.forEach((g, gi) => {
        $$('button', g).forEach(b => {
          const test = sel.slice(); test[gi] = b.dataset.value;
          const ok = data.variants.some(v2 => v2.available && v2.options.every((o, i) => test[i] == null || o === test[i]));
          b.classList.toggle('na', !ok);
          b.setAttribute('aria-pressed', String(b.dataset.value === sel[gi]));
        });
        const lab = $('[data-selected]', g.parentElement); if (lab) lab.textContent = sel[gi] ?? '';
      });
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s> <span class="sale">${formatMoney(v.price)}</span>` : formatMoney(v.price));
        if (skuEl) skuEl.textContent = v.sku ? `Réf. ${v.sku}` : '';
        const st = $('[data-stock]', root);
        if (st) {
          const low = Number(st.dataset.low || 5);
          const n = v.tracked ? v.inv : null;
          st.hidden = !(v.available && n !== null && n > 0 && n <= low) && !(st.dataset.showOk === 'true' && v.available);
          st.classList.toggle('ok', !(n !== null && n <= low));
          $('span', st).textContent = (n !== null && n > 0 && n <= low) ? `Plus que ${n} en stock` : 'En stock, expédié en 3 à 4 jours ouvrés';
        }
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? labels.add : labels.sold; }
        if (v.featured_media) {
          const m = $(`[data-media-id="${v.featured_media.id}"]`, root);
          const gal = m?.parentElement;
          if (m && gal && gal.firstElementChild !== m) gal.insertBefore(m, gal.firstElementChild);
        }
        if (root.dataset.updateUrl === 'true') history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
        const accent = $('[data-accent]', root); if (accent && sel[0]) accent.textContent = sel[0];
      } else if (addBtn) { addBtn.disabled = false; addBtn.textContent = labels.add; }
    }

    groups.forEach((g, gi) => g.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      sel[gi] = b.dataset.value;
      if (hint && g.dataset.required === 'true') { hint.classList.remove('err'); hint.textContent = `${b.dataset.value} sélectionné`; }
      paint();
    }));

    $$('[data-qty]', root).forEach(b => b.addEventListener('click', () => {
      const i = $('input[name="quantity"]', root); i.value = Math.max(1, Number(i.value || 1) + Number(b.dataset.qty));
    }));

    form?.addEventListener('submit', async e => {
      e.preventDefault();
      const v = current();
      if (!v) {
        if (hint) { hint.textContent = hint.dataset.err || 'Choisissez votre taille pour continuer'; hint.classList.add('err'); }
        return;
      }
      if (!v.available) return;
      addBtn.disabled = true;
      await addToCart(new FormData(form), `${data.title}${data.variants.length > 1 ? ' · ' + v.title : ''}`);
      addBtn.disabled = false;
    });
    paint();
  });

  /* gallery: tap a thumbnail to show it large */
  $$('.gallery').forEach(gal => gal.addEventListener('click', e => {
    const item = e.target.closest('.gallery > *');
    if (!item || item === gal.firstElementChild || item.querySelector('video, iframe, model-viewer')) return;
    gal.insertBefore(item, gal.firstElementChild);
    if (gal.getBoundingClientRect().top < 0) gal.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* countdown */
  $$('[data-countdown]').forEach(root => {
    const t = Date.parse(root.dataset.target);
    if (isNaN(t)) { root.hidden = true; return; }
    const el = k => $(`[data-${k}]`, root);
    const pad = n => String(n).padStart(2, '0');
    const dateEl = $('[data-cd-date]', root);
    if (dateEl) dateEl.textContent = new Date(t).toLocaleString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' }) + ' (Paris)';
    const tickCd = () => {
      let s = Math.max(0, Math.floor((t - Date.now()) / 1000));
      if (s === 0) { root.classList.add('done'); $('[data-cd-after]', root).hidden = false; clearInterval(timer); return; }
      el('d').textContent = pad(Math.floor(s / 86400)); s %= 86400;
      el('h').textContent = pad(Math.floor(s / 3600)); s %= 3600;
      el('m').textContent = pad(Math.floor(s / 60));
      el('s').textContent = pad(s % 60);
    };
    const timer = setInterval(tickCd, 1000); tickCd();
  });

  /* scroll reveal + parallax */
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (DL.animations && !reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('anim');
    const sel = '.sec-hd, .cat, .grid > .card, .look figure, .spot-in > *, .usp > div, .news-in > *, .cd-in > *, .section.wrap > div > .disp, .rte, .ft > div, .coll-hd';
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$(sel, $('main') || document).forEach(n => {
      if (n.closest('.drawer, .hero, dialog')) return;
      const sibs = [...n.parentElement.children].filter(c => c.matches(sel));
      n.style.setProperty('--rv-d', Math.min(sibs.indexOf(n), 5) * 0.07 + 's');
      n.classList.add('rv'); io.observe(n);
    });
    const px = $$('.hero-media img, .hero-media video, .look figure img');
    px.forEach(i => { i.dataset.parallax = ''; i.style.transform = 'scale(1.12)'; });
    let raf = 0;
    const onScroll = () => {
      raf = 0;
      const vh = innerHeight;
      px.forEach(i => {
        const r = i.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        i.style.transform = `translate3d(0, ${(p * -6).toFixed(2)}%, 0) scale(1.12)`;
      });
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(onScroll); }, { passive: true });
    onScroll();
    // safety net: never leave visible content hidden if the observer is slow
    const reveal = () => $$('.rv:not(.in)').forEach(n => { if (n.getBoundingClientRect().top < innerHeight) n.classList.add('in'); });
    addEventListener('scroll', () => setTimeout(reveal, 400), { passive: true });
    setTimeout(reveal, 1200);
  }

  /* lightbox / zoom on main product photo */
  document.addEventListener('click', e => {
    const first = e.target.closest('[data-product-form] .gallery > :first-child');
    if (!first) return;
    const img = $('img', first); if (!img) return;
    const src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2400');
    const lb = document.createElement('div');
    lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-label', 'Photo agrandie');
    lb.innerHTML = `<button type="button" aria-label="Fermer"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img src="${esc(src)}" alt="">`;
    const big = $('img', lb);
    const close = () => { lb.remove(); document.body.classList.remove('no-scroll'); removeEventListener('keydown', onKey); };
    const onKey = ev => { if (ev.key === 'Escape') close(); };
    lb.addEventListener('click', ev => {
      if (ev.target.closest('button')) return close();
      if (ev.target !== big) return close();
      lb.classList.toggle('zoom');
      const r = big.getBoundingClientRect();
      big.style.transformOrigin = `${((ev.clientX - r.left) / r.width) * 100}% ${((ev.clientY - r.top) / r.height) * 100}%`;
    });
    lb.addEventListener('mousemove', ev => {
      if (!lb.classList.contains('zoom')) return;
      const r = big.getBoundingClientRect();
      big.style.transformOrigin = `${((ev.clientX - r.left) / r.width) * 100}% ${((ev.clientY - r.top) / r.height) * 100}%`;
    });
    addEventListener('keydown', onKey);
    document.body.appendChild(lb); document.body.classList.add('no-scroll');
    $('button', lb).focus();
  });

  /* size guide dialog + advisor */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-open-dialog]'); if (!b) return;
    const d = document.getElementById(b.dataset.openDialog); if (d && d.showModal) d.showModal();
  });
  $$('dialog.sg').forEach(d => {
    d.addEventListener('click', e => { if (e.target === d || e.target.closest('[data-close-dialog]')) d.close(); });
    const adv = $('[data-advisor]', d); if (!adv) return;
    const rows = JSON.parse(adv.dataset.advisor || '[]');
    const out = $('output', adv);
    const calc = () => {
      const h = Number($('[name=h]', adv).value), w = Number($('[name=w]', adv).value);
      if (!h || !w) { out.textContent = ''; return; }
      let i = rows.findIndex(r => h <= r.hmax && w <= r.wmax);
      if (i < 0) i = rows.length - 1;
      const up = adv.dataset.sizeUp === 'true';
      const j = up ? Math.min(i + 1, rows.length - 1) : i;
      if (!rows[j]) { out.textContent = ''; return; }
      out.textContent = up && j === i && i === rows.length - 1 && rows.length > 1
        ? `Taille conseillée : ${rows[j].size} (notre plus grande taille, la coupe est petite)`
        : `Taille conseillée : ${rows[j].size}` + (up && j !== i ? ` (au lieu du ${rows[i].size} habituel, la coupe est petite)` : '');
    };
    adv.addEventListener('input', calc);
  });

  /* sticky add to cart (product page) */
  $$('[data-satc]').forEach(bar => {
    const root = bar.closest('[data-product-section]') || document;
    const mainBtn = $('[data-add]', root); if (!mainBtn) return;
    const priceSrc = $('[data-price]', root);
    const sync = () => { $('[data-satc-price]', bar).innerHTML = priceSrc ? priceSrc.innerHTML : ''; $('[data-satc-btn]', bar).disabled = mainBtn.disabled; $('[data-satc-btn]', bar).textContent = mainBtn.textContent.trim(); };
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    if (priceSrc) new MutationObserver(sync).observe(priceSrc, { childList: true, subtree: true });
    sync();
    const check = () => {
      const show = mainBtn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('show', show); document.body.classList.toggle('has-satc', show);
      bar.setAttribute('aria-hidden', String(!show));
    };
    addEventListener('scroll', check, { passive: true }); addEventListener('resize', check); check();
    $('[data-satc-btn]', bar).addEventListener('click', () => {
      const hint = $('[data-size-hint]', root);
      mainBtn.click();
      if (hint && hint.classList.contains('err')) hint.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* complete the look (recommendations API) */
  $$('[data-reco]').forEach(async box => {
    try {
      const r = await fetch(`${DL.routes?.reco || '/recommendations/products'}?section_id=${box.dataset.section}&product_id=${box.dataset.product}&limit=${box.dataset.limit}&intent=${box.dataset.intent}`);
      const html = await r.text();
      const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-reco]');
      if (inner && inner.querySelector('.card')) { box.innerHTML = inner.innerHTML; box.closest('section').hidden = false; syncFavs(); }
    } catch {}
  });

  /* auto-submit (sort / filter) */
  $$('[data-autosubmit]').forEach(el => el.addEventListener('change', () => el.form.submit()));

  /* newsletter success note */
  if (location.search.includes('customer_posted=true')) toast('Merci ! Vous êtes bien inscrite.');

  window.DLTheme = { refreshCart, addToCart, formatMoney, toast };
  if (DL.cart) renderCart(DL.cart);
  // keep the drawer fresh when coming back via the browser cache
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });
})();

/* Jaymis : bandeau d'annonces qui tourne + carrousels produits */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-announce]').forEach(bar => {
    const items = [...bar.children]; if (items.length < 2 || reduce) return;
    let i = 0; const ms = (Number(bar.dataset.interval) || 4) * 1000;
    setInterval(() => { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, ms);
  });
  document.querySelectorAll('.jc-rail-band').forEach(band => {
    const rail = band.querySelector('[data-rail]'); if (!rail) return;
    band.querySelectorAll('[data-rail-dir]').forEach(b => b.addEventListener('click', () =>
      rail.scrollBy({ left: Number(b.dataset.railDir) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' })));
  });
})();
